
import apple_logo from '../../util/imgs/apple_logo.svg';
  
export default apple_logo;
  